<template>
    <div class="step2-container">
        <div @scroll="scrollToEnd" class="main-content-container no-scrollbar">
            <div class="storefront-header" :style="storefrontHeaderConfig ? 'background-color:' + storefrontHeaderConfig.color : ''" v-if="currentOccassionImage">
                <div class="custom-header" v-if="showCustomHeader">
                    <img :src="storefrontHeaderConfig.image"/>
                    <p>{{ storefrontHeaderConfig.text }}</p>
                </div>
            </div>
            <div id="header-container" class="header-container" :class="isSticking ? 'sticky' : '' ">
                <div class="sticky-image-container">
                    <p class="steps">
                        STEP 1: Add gifts!
                    </p>
                </div>
                <div v-if="secondOccasions && secondOccasions.length > 0" class="filter-categories-container">
                    <p class="title">
                        <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/filters.png?v=1722266559">
                        Filter by:
                    </p>
                    <div class="categories-container no-scrollbar">
                        <button 
                            v-for="occasion of secondOccasions.slice(0, 3)" 
                            :key="occasion.title"
                            @click="setSelectedOccasion(occasion.title)" 
                            class="step-button"
                            :class="selectedOccasion.includes(occasion.title) ? 'selected' : ''"
                        > 
                            {{occasion.title}}
                        </button>
                    </div>
                    <button class="happybox-button white border" @click="showFilters()">+ Filters</button>
                </div>
            </div>
            <div class="content-container">
                <ul v-if="!notFilter" class="products-container no-scrollbar">
                    <p class="other-gifts" v-if="nonFilteredProducts.length > 0">{{breadcrumbText}}</p>
                    <li v-for="addonProduct in sortedProducts" :key="addonProduct.id">
                        <AddonProductNew @loadmodal="openModal($event)" :product="addonProduct" :cartProducts="selectedAddonProducts" :addCopy="addCopy"/>
                    </li>
                    <p class="other-gifts" v-if="nonFilteredProducts.length > 0">All Other Gifts</p>
                    <li v-for="addonProduct in nonFilteredProducts" :key="addonProduct.id">
                        <AddonProductNew @loadmodal="openModal($event)" :product="addonProduct" :cartProducts="selectedAddonProducts" :addCopy="addCopy"> </AddonProductNew>
                    </li>
                </ul>
                <ul v-else class="products-container no-scrollbar">
                    <template v-if="showReco && recoProducts.length > 0">
                        <p class="other-gifts">Recommended</p>
                        <li v-for="addonProduct in recoProducts" :key="addonProduct.id + 'reco'">
                            <AddonProductNew 
                            @loadmodal="openModal($event)" 
                            :product="addonProduct" 
                            :cartProducts="selectedAddonProducts"
                            :maxCapacity="maxCapacity"
                            :currentCapacity="currentCapacity"
                            :boxQty="boxQty"
                            :productLimit="productLimit"
                            :addCopy="addCopy"
                            />
                        </li>
                    </template>
                    <template v-for="set in occasionProducts">
                        <p class="other-gifts">{{set.occasion == "Storefront" ? corpName + " Products" : set.occasion}}</p>
                        <li v-for="addonProduct in set.products" :key="addonProduct.id + set.occasion">
                            <AddonProductNew v-if=" addonProduct != 'ad'" @loadmodal="openModal($event)" :product="addonProduct" :cartProducts="selectedAddonProducts" :addCopy="addCopy"> </AddonProductNew>
                            <div v-else class="promotion">
                                <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/cross_promotion_packaging_logo.png?v=1721312901" alt="promotion"/>
                                <div class="floating-container">
                                    <p class="title">Want custom packaging or swag?</p>
                                    <p class="subtitle">We do that too. <span>*minimums apply</span></p>
                                    <a target="_blank" href="/pages/corporate-gifts" class="happybox-button white border">Learn More</a>
                                </div>
                            </div>
                        </li>
                        <p v-if="showReco && recoProducts.length > 0 && set.occasion.includes(corpName)" class="other-gifts">Recommended</p>
                        <li v-if="showReco && recoProducts.length > 0 && set.occasion.includes(corpName)" v-for="addonProduct in recoProducts" :key="addonProduct.id + 'reco'">
                            <AddonProductNew 
                            @loadmodal="openModal($event)" 
                            :product="addonProduct" 
                            :cartProducts="selectedAddonProducts"
                            :maxCapacity="maxCapacity"
                            :currentCapacity="currentCapacity"
                            :boxQty="boxQty"
                            :productLimit="productLimit"
                            :addCopy="addCopy"
                            />
                        </li>
                    </template>
                </ul>
            </div>
        </div>
        <SideCartMobile v-if="selectedAddonProducts.length > 0" @openmodal="openModal($event)" @changepage="changePage($event)" :recommendedAddons="modalRecommendedProducts" :cartProducts="selectedAddonProducts"/>
        <AddonProductModalMobile 
            :showModal="showModal"
            :selectedAddon="currentSelectedAddon"
            :addonProducts="modalProducts"
            :cartProducts="selectedAddonProducts"
            :recommendedProducts="modalRecommendedProducts"
            @closemodal="closeModal()"
            @changeselectedaddon="openModal($event)"
        />
        <BrandableProductModal 
            v-if="showBrandableModal == true && currentSelectedAddon != null" 
            :selectedAddon="currentSelectedAddon"
            :addonProducts="modalProducts"
            :cartProducts="selectedAddonProducts"
            :recommendedProducts="modalRecommendedProducts"
            @closemodal="closeModal()"
            @changeselectedaddon="openModal($event)"
        />
        <FiltersMobile @goall="goAll" :filteredPreAddons="filteredPreProducts" @closefilter="showFilters()" v-if="filterIsShown" :filteredAddons="sortedProducts"/>
    </div>
</template>
    
<script>
import AddonProductNew from '../AddonProductNew.vue';
import SideCartMobile from './SideCartMobile.vue'
import AddonProductModalMobile from './AddonProductModalMobile.vue'
import FiltersMobile from './FiltersMobile.vue'
import { mapGetters } from 'vuex';
import smoothReflow from 'vue-smooth-reflow'
import BrandableProductModal from '../AddonProductModal.vue'

export default {
    mixins: [smoothReflow],
    components: {
        AddonProductNew,
        SideCartMobile,
        AddonProductModalMobile,
        FiltersMobile,
        BrandableProductModal
    },
    data() {
        return{
            selectedAddon: null,
            showModal: false,
            showBrandableModal: false,
            isAllItems: false,
            filterIsShown: false,
            isSticking: false,
            selectedSecondOccasion: null,
        }
    },
    computed: {
        ...mapGetters([
            'addonProducts',
            'selectedAddonProducts',
            'categories',
            'occasions',
            'boxQty',
            'maxCapacity',
            'currentCapacity',
            'selectedSort',
            'rangePrice',
            'selectedCategories',
            'selectedFilters',
            'boxQty',
            'addCopy',
            'budget',
            'currentBudget',
            'storefrontHeaderConfig',
            'corpName'
        ]),
        selectedOccasion: {
            get(){ return this.$store.state.selectedOccasion},
            set(value){this.$store.commit('setSelectedOccasion', value )}
        },
        selectedOccasionMobile: {
            get(){ return this.$store.state.selectedOccasionMobile},
            set(value){this.$store.commit('setSelectedOccasionMobile', value )}
        },
        notFilter(){
            return this.selectedOccasion.length == 0 && this.selectedFilters.length == 0
        },
        breadcrumbText(){
            if(this.showReco)
                return `All products > Recommended Gifts`
            let text = "";
            if(this.selectedOccasion.length > 0)
                text += this.selectedOccasion.join(", ");
            else 
                text += "All products";

            if(!this.selectedCategories.includes("View All"))
                text += ` > ${this.selectedCategories.join(", ")}`
            return text;
        },
        showReco(){
            return this.selectedOccasion.length == 0 && this.selectedFilters.length == 0 && this.selectedCategories.includes("View All");
        },
        recoProducts(){
            let products = this.addonProducts.filter(x => x.tags.some(y => y.toLowerCase() == "builder_reco"))

            return products
        },
        occasionProducts(){
            let products = [];
            if(this.categories && this.categories.filters && this.categories.filters.length > 0){
                for(let [i, occasion] of this.categories.filters.entries()){
                    let current = this.addonProducts.filter(x => x.tags.some(y => y.includes(occasion.title)));
                    if(current.length > 0){
                        if(i == 0){
                            current.splice(3, 0, "ad");
                        }
                        switch(this.selectedSort){
                            case "2":
                                current.sort((a,b) => {
                                    var aIsIncluded = a.tags.some(x => x.includes("Filter_Badges_Best Sellers"));
                                    var bIsIncluded = b.tags.some(x => x.includes("Filter_Badges_Best Sellers"));
                                    if(aIsIncluded == bIsIncluded){
                                        return 0;
                                    }
                                    else if(aIsIncluded == true){
                                        return -1;
                                    }
                                    else if(bIsIncluded == true){
                                        return 1;
                                    }
                                });
                                break
                            case "3":
                                current.sort((a,b) => {
                                    var aIsIncluded = this.dateDiffInDays(new Date(a.published_at),new Date()) < 60;
                                    var bIsIncluded = this.dateDiffInDays(new Date(b.published_at),new Date()) < 60;
                                    if(aIsIncluded == bIsIncluded){
                                        return 0;
                                    }
                                    else if(aIsIncluded == true){
                                        return -1;
                                    }
                                    else if(bIsIncluded == true){
                                        return 1;
                                    }
                                })
                                break
                            case "4":
                                current.sort((a,b) => { return a.variants[0].price - b.variants[0].price});
                                break;
                            case "5":
                                current.sort((a,b) => { return b.variants[0].price - a.variants[0].price})
                                break;
                            default:
                                break;
                        }
                        products.push({occasion: occasion.title,products: current});
                    }
                }
            }
            if(!this.selectedCategories.includes("View All")){
                products.sort((a,b) => {
                    let iA = this.selectedCategories.includes(a.occasion) ? 1 : 0;
                    let iB = this.selectedCategories.includes(b.occasion) ? 1 : 0;

                    return iB - iA;
                })
            }

            return products
        },
        filteredPreProducts(){
            let filterAddons =  JSON.parse(JSON.stringify(this.addonProducts));
            //filter via occasion
            if(this.selectedOccasion.length > 0){
                filterAddons = filterAddons.filter(x => x.tags.some(y => this.selectedOccasion.some(z => y.includes(z))));
            }

            //Filter categories
            if(!this.selectedCategories.includes("View All"))
                filterAddons = filterAddons.filter(x => x.tags.some(y =>  this.selectedCategories.some(z => y.includes(z))));

            //Filter for each category
            for(let filter of this.selectedFilters){
                filterAddons = filterAddons.filter(x => filter.filters.some(y => x.tags.includes(y)));
            }

            //Exclude products
            let excludeFilters = this.selectedAddonProducts.filter(x => x.tags.some(y => y.includes("Exclude_")));
            if(excludeFilters.length > 0){
                let excludedTags = excludeFilters.flatMap(x => x.tags.filter(y => y.includes("Exclude_")));
                excludedTags = excludedTags.map(x => parseInt(x.replaceAll("Exclude_","")));
                filterAddons = filterAddons.filter(x => !excludedTags.includes(x.id));
            }
            
            return filterAddons;
        },
        filteredProducts(){
            //Filter Price
            return this.filteredPreProducts.filter(x => ((x.variants[0].price-this.rangePrice.min)*(x.variants[0].price-this.rangePrice.max) <= 0));
        },
        nonFilteredProducts(){
            let ids = this.filteredProducts.map(x => x.id);
            let excludeFilters = this.selectedAddonProducts.filter(x => x.tags.some(y => y.includes("Exclude_")));
            if(excludeFilters.length > 0){
                let excludedTags = excludeFilters.flatMap(x => x.tags.filter(y => y.includes("Exclude_")));
                excludedTags = excludedTags.map(x => parseInt(x.replaceAll("Exclude_","")));
                return this.addonProducts.filter(x => !ids.includes(x.id) && !excludedTags.includes(x.id));
            }
            return this.addonProducts.filter(x => !ids.includes(x.id));
        },
        sortedProducts(){
            var sortedProducts = JSON.parse(JSON.stringify(this.filteredProducts));
            switch(this.selectedSort){
                case "2":
                    sortedProducts.sort((a,b) => {
                        var aIsIncluded = a.tags.some(x => x.includes("Filter_Badges_Best Sellers"));
                        var bIsIncluded = b.tags.some(x => x.includes("Filter_Badges_Best Sellers"));
                        if(aIsIncluded == bIsIncluded){
                            return 0;
                        }
                        else if(aIsIncluded == true){
                            return -1;
                        }
                        else if(bIsIncluded == true){
                            return 1;
                        }
                    });
                    break
                case "3":
                    sortedProducts.sort((a,b) => {
                        var aIsIncluded = this.dateDiffInDays(new Date(a.published_at),new Date()) < 60;
                        var bIsIncluded = this.dateDiffInDays(new Date(b.published_at),new Date()) < 60;
                        if(aIsIncluded == bIsIncluded){
                            return 0;
                        }
                        else if(aIsIncluded == true){
                            return -1;
                        }
                        else if(bIsIncluded == true){
                            return 1;
                        }
                    })
                    break
                case "4":
                    sortedProducts.sort((a,b) => { return a.variants[0].price - b.variants[0].price});
                    break;
                case "5":
                    sortedProducts.sort((a,b) => { return b.variants[0].price - a.variants[0].price})
                    break;
                default:
                    break;
            }

            //Filter onDemand Product
            sortedProducts = sortedProducts.filter((x) => {
                let inCart = this.selectedAddonProducts.find(y => y.id == x.id );
                if(inCart)
                    return true;
                let indexVariant =  x.variants.findIndex(x => x.sku && x.sku.toLowerCase().includes("ondemand"));
                if(indexVariant > -1){
                    if(this.boxQty >= this.demandQtyMin(x)){
                        return true
                    }
                    else {
                        let indexNotDemand =  x.variants.findIndex(x => !x.sku.toLowerCase().includes("ondemand"));
                        return x.variants[indexNotDemand].inventory_quantity >= this.boxQty
                    }
                }

                return x.variants.some(y => y.inventory_quantity >= this.boxQty);
            })

            return sortedProducts;
        },
        currentSelectedAddon(){
            if(this.selectedAddon){
                return this.selectedAddon;
            }
            else
                return null
        },
        recommendedAddons(){
            if(this.addonProducts.length > 0){
                //here goes recommendation logic
                var addonCartIds = this.selectedAddonProducts.map(x => x.id)
                var recommendedAddons = JSON.parse(JSON.stringify(this.addonProducts));
                //First remove every product that does not fit,has enough quantity or is already inside the box
                recommendedAddons = recommendedAddons.filter(x => {
                    let qtyMin = x.tags.find(x => x.includes("QTYMIN"));

                    if(qtyMin){
                        qtyMin = qtyMin.split("_");
                        qtyMin = parseInt(qtyMin[qtyMin.length - 1]);

                        if(qtyMin > this.boxQty){
                            return false
                        }
                    }

                    return (this.maxCapacity >= (this.currentCapacity + x.capacity)) 
                    && (this.boxQty < x.variants[0].inventory_quantity)
                    && (parseInt(x.variants[0].price) + this.currentBudget) <= this.budget
                    && !addonCartIds.includes(x.id);
                });

                //sort by capacity
                recommendedAddons.sort((a, b) => b.capacity - a.capacity);

                //return the first three results
                return recommendedAddons.slice(0, 3);
            }

            return [];
        },
        modalProducts(){
            var addonCartIds = this.selectedAddonProducts.map(x => x.id)
            return this.sortedProducts.filter(x => 
                ((this.maxCapacity > (this.currentCapacity + x.capacity)) 
                && (this.boxQty < x.variants[0].inventory_quantity)
                && (parseInt(x.variants[0].price) + this.currentBudget) <= this.budget
                )
                || addonCartIds.includes(x.id)
            )
        },
        modalRecommendedProducts(){
            var addonCartIds = this.selectedAddonProducts.map(x => x.id);
            if(this.filteredPreProducts.length > 0){
                let products = this.filteredPreProducts.filter(x => !addonCartIds.includes(x.id) && x.tags.every(y => !y.includes("Brandable Swag") && !y.toLowerCase().includes("Pairs_exclude")) && ((parseInt(x.variants[0].price) + this.currentBudget) <= this.budget));
                return products.sort((a,b) => a.capacity - b.capacity);
            }
            else{
                return this.addonProducts.filter(x => !addonCartIds.includes(x.id) && x.tags.every(y => !y.includes("Brandable Swag") && !y.toLowerCase().includes("Pairs_exclude"))).sort((a,b) => a.capacity - b.capacity && ((parseInt(x.variants[0].price) + this.currentBudget) <= this.budget));
            }
        },
        secondOccasions(){
            return this.occasions.filter(x => x.title != "View All");
        },
        showCustomHeader(){
            return this.storefrontHeaderConfig && this.storefrontHeaderConfig.color && this.storefrontHeaderConfig.image;
        }
    },
    methods: {
        openModal(product){
            ga('send', {
                hitType: 'event',
                eventCategory: 'Build A Box',
                eventAction: 'Open Product',
                eventLabel: product.title
            });
            this.selectedAddon = product;
            var isBrandable = this.selectedAddon.tags.filter(y => y.includes("Brandable Swag"));
            let designable = this.selectedAddon.tags.filter(y => y.includes("Designable"));
            if(isBrandable && isBrandable.length > 0 && (this.selectedAddon.variants.length > 1 || (designable && designable.length > 0))){
                this.showBrandableModal = true
            }
            else
                this.showModal = true;
        },
        closeModal(){
            this.showModal = false;
            this.showBrandableModal = false;
            this.selectedAddon = null;
        },
        changePage(increment){
            this.$emit("changepage", increment);
        },
        dateDiffInDays(a, b) {
            const _MS_PER_DAY = 1000 * 60 * 60 * 24;
            // Discard the time and time-zone information.
            const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
            const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
            return Math.floor((utc2 - utc1) / _MS_PER_DAY);
        },
        showFilters(){
            this.filterIsShown = !this.filterIsShown;
        },
        goAll(){
            const pageContainer = document.getElementById('PageContainer');
            if (pageContainer) pageContainer.scrollTop = 0;
        },
        scrollToEnd({ target: { scrollTop, clientHeight, scrollHeight }}) {
            if (scrollTop + clientHeight >= scrollHeight && (this.isAllItems == true || this.selectedOccasion == "View All")) {
                ga('send', {
                    hitType: 'event',
                    eventCategory: 'Build A Box',
                    eventAction: 'Product Selection',
                    eventLabel: 'End Scroll'
                });
            }
        },
        demandQtyMin(addon){
            let demandQtymin = addon.tags.find(x => x.includes("DEMAND_QTYMIN"));
            if(demandQtymin){
                if(demandQtymin){
                    demandQtymin = demandQtymin.split("_");
                    demandQtymin = demandQtymin[demandQtymin.length - 1];

                    return  parseInt(demandQtymin);
                }
            }

            return 0;
        },
        scrollToTop(){
            var myDiv = document.getElementById('scroll-container');
            myDiv.scrollTop = 0;
        },
        setSelectedOccasion(value){
            this.selectedOccasion = value;
            this.selectedOccasionMobile = value;
        },
    },
    mounted(){
        var that = this;
        var element = document.getElementById("header-container");
        var observer = new IntersectionObserver(function(entries) {
            if(entries[0].intersectionRatio < 1){
                setTimeout(function(){
                    that.isSticking = true;
                }, 200);
            }
            else{
                setTimeout(function(){
                    that.isSticking = false;
                }, 200);
            }
        }, { threshold: [0,1] });

        observer.observe(element);
    }
}
</script>

<style scoped>

.step2-container{
    width: 100%;
    height: 100%;
    display: flex;
}

.main-content-container{
    min-width: 90%;
    width: 100%;
    max-width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.products-count-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2% 5%;
}

.products-count-container p{
    font-size: 3vw;
}

.products-count-container button{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 1% 5%;
    background-color: #FFFFFF;
    border: 1px solid #0F0C38;
    border-radius: 100px;
    color:#0F0C38;
    font-size: 3vw;
}

.main-content-container .content-container{
    width: 100%;
    display: flex;
    flex-direction: column;
}

.main-content-container .header-container{
    width: 100%;
    position: sticky;
    top: -1px;
    background-color: white;
    z-index: 3;
}

.main-content-container .header-container.sticky{
    padding-top: 1px;
}

.categories-container{
    flex: 4;
    display: flex;
    align-items: center;
    white-space: nowrap;
    padding: 2% 0%;
}

.categories-container button{
    margin: 0% 1%;
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 2.5vw;
    line-height: 1.3;
    color: #7A7991;
    padding: 2%;
    border-radius: 20px;
    border: 1px solid lightgray;
}

.categories-container button.selected{
    color: white;
    background-color: #0F0C38;
}
.products-container{
    width: 100%;
    height: fit-content;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    overflow-y: scroll;
    margin: 0;
    padding: 5%;
}

.products-container li{
    width: 50%;
    display: inline-block;
    padding: 0% 2.5%;
    flex-shrink: 0;
}

.category-products-container .products-container li{
    width: 70%;
}

.recommended-product-container{
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    justify-content: space-between;
    overflow-y: scroll;
}

.recommended-category{
    font-family: Moret;
    font-size: 2rem;
    color: #0F0C38;
    line-height: 1.23;
    padding: 2% 0%;
}

.category-products-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 5%;
}

.category-products-container .products-container{
    width: 100%;
    padding: unset;
    margin: 0;
    white-space: nowrap;
    flex-wrap: nowrap;
}

.shop-all{
    background-color: #ffd45f;
    box-shadow: 0px 1px 2px rgba(31, 41, 55, 0.08);
    border-radius: 100px;
    padding: 0.5rem 1rem;
    font-family: 'Karla';
    font-weight: 700;
    font-size: 1rem;
    line-height: 150%;
    display: flex;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #0F0C38;
}

.shop-all:hover{
    background-color: #F6BC41;
}

.view-all-products-container{
    width: 100%;
    height: 76%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #FFF1F2;
    border: 1px dashed #0F0C38;
    box-sizing: border-box;
    text-align: center;
}

.other-gifts{
    width: 100%;
    border-bottom: 0.5px solid gray;
    margin-bottom: 4%;
    font-size: 4vw;
    font-weight: bold;
}

.filter-categories-container{
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0% 2%;
    box-shadow: 0 1px #0003;
}

.filter-categories-container .title{
    flex: 2;
    font-size: 3vw;
    display: flex;
    gap: 5px;
    font-weight: bold;
    align-items: center;
}

.filter-categories-container .title img{
    width: 15px;
}

.filter-categories-container .white{
    font-size: 3vw;
    flex: 2;
    padding: 0.5%;
}

.video-container{
    width: 100%;
    display: flex;
    position: relative;
}

.title-container{
    width: 65%;
    position: absolute;
    top: 0%;
    right: 0%;
    text-align: center;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.title-container .title{
    font-size: 7vw;
    line-height: 0.8;
    font-family: Founders Grotesk, sans-serif;
    font-weight: 600;
    margin: unset;
    margin-bottom: 0.5rem;
}

.title-container .instructions{
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
}

.title-container .instructions div{
    width: 32%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.title-container .instructions div img{
    margin-bottom: 0.5rem;
    height: 7vw;
    max-width: 50%;
}

.title-container .instructions .first img{
    max-width: 40%;
}

.title-container .instructions div p{
    font-size: 2vw;
    line-height: 1.2;
    font-weight: bold;
}

.sticky-image-container{
    width: 100%;
    flex-direction: column;
    align-items: center;
    display: none;
}

.sticky .sticky-image-container{
display: flex;
}

.sticky-image-container .steps{
    width: 100%;
    font-size: 3vw;
    line-height: 1.5;
    font-weight: 700;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.75rem 0;
}

.sticky-image-container .steps .dot span.selected{
    opacity: 1;
}
</style>